import { combineReducers } from 'redux';

import { reducer as account } from './account';
import { reducer as address } from './address';
import { reducer as commissions } from './commissions';
import { reducer as rates } from './rates';
import { reducer as refer } from './refer';
import { reducer as referrals } from './referrals';
import { reducer as clientManagement } from './clientManagement';
import { reducer as register } from './register';
import { reducer as user } from './user';
import { reducer as notifications } from './notifications';
import { reducer as resources } from './resources';
import { reducer as uiStates } from './uistates';
import { reducer as bankDetails } from './bankDetails';
import { reducer as servicesDowntime } from './servicesDowntime';
import { reducer as invoices } from './invoices';
import { reducer as dialingCode } from "./dialingCode";
import { reducer as partnerRegister } from "./partnerRegister";

import { RESET_REDUX_STORE_TO_INITIAL_STATE } from '../modules/user/types';

const reducer = combineReducers({
  account,
  address,
  commissions,
  rates,
  refer,
  referrals,
  clientManagement,
  register,
  user,
  notifications,
  resources,
  uiStates,
  bankDetails,
  servicesDowntime,
  invoices,
  dialingCode,
  partnerRegister
});

export const rootReducer = (state, action) => {
  if (action.type === RESET_REDUX_STORE_TO_INITIAL_STATE) {
    const { user: userData, servicesDowntime: servicesDowntimeStatus } = state;

    const updatedUserData = {
      ...userData,
      affiliateDetails: null
    }

    state = { user: updatedUserData, servicesDowntime: servicesDowntimeStatus };
  }
  return reducer(state, action);
}

export type ReducerState = ReturnType<typeof rootReducer>;
